<div class="radio-buttons" [ngClass]="'radio-buttons--align-' + align">
  <div *ngFor="let option of options" class="radio-button-wrapper">
    <button
      class="radio-button"
      [ngClass]="{ 'radio-button--selected': option.value === selected }"
      (click)="change.emit(option)"
    >
      <qbe-custom-icons *ngIf="option.qbeIcon" class="radio-button--icon" [icon]="option.qbeIcon" />
      <nx-icon *ngIf="option.ndbxIcon" class="radio-button--icon" [name]="option.ndbxIcon" size="m" />
      <p nxCopytext="medium">{{option.label | translate}}</p>
    </button>
  </div>
</div>
